import { useState } from 'react';

import { Layout } from '@.layout';
import { Board } from '@.partials';
import { useDictionaries, useStickyShadowHead } from '@/Components/Hooks';
import { Filter3, FilterData } from '@/Components/UI';

import { IndexWizard, New, Popular } from './items';

export const Dashboard: React.FC = () => {
    const { refComponent } = useStickyShadowHead();

    const [filters, setFilters] = useState<FilterData>({});
    const [dictionaries] = useDictionaries(
        'Companies',
        'StoreGroups',
        'Stores',
        'Brands',
        'ProductTypes',
        'Ages',
        'Stations',
        'Sexes',
        'Strengths',
        'Occasions',
        'Ingredients',
        'Characters',
        'IsArchived',
        'Tags',
        'OrderStatuses',
        'ProductUdis'
    );

    const handleFilters = (data: FilterData) => setFilters(data);

    return (
        <Layout nobg name="dashboard" breadcrumbs={[{ name: 'Dashboard', current: true }]}>
            <Board>
                <Board.Item head ref={refComponent}>
                    <h1>Dashboard</h1>
                    <Filter3 onChange={handleFilters}>
                        <Filter3.Companies related localSearch />
                        <Filter3.StoreGroups related localSearch />
                        <Filter3.Stores related localSearch />
                        <Filter3.Stations related />
                        <Filter3.Date />
                    </Filter3>
                </Board.Item>
                <IndexWizard filters={filters} />
                <Popular dictionaries={dictionaries} filters={filters} />
                <New dictionaries={dictionaries} filters={filters} />
            </Board>
        </Layout>
    );
};
